import React from 'react';
import style from './style.scss';
import Product from 'components/partials/product';
import ItemProductOther from './ItemProductOther.jsx';
import {Businesses} from 'api';

class ListProductOther extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    if (this.props.businessId) {
      const params = {
        id: this.props.businessId,
        filter: {
          limit: 6,
          where: {
            id: {
              neq: this.props.productId
            }
          }
        }
      };
      Businesses.actions.listProducts.request(params).then(response => {
        this.setState({data: response.data});
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.businessId) {
      const params = {
        id: nextProps.businessId,
        filter: {
          limit: 6,
          where: {
            id: {
              neq: nextProps.productId
            }
          }
        }
      };
      Businesses.actions.listProducts.request(params).then(response => {
        this.setState({data: response.data});
      });
    }
  }

  render() {
    if (this.state.data.length === 0) {
      return null;
    }
    return (
      <section className="list-product-other">
        <h2 className='product-other-title'>Các sản phẩm khác của doanh nghiệp</h2>
        {
          this.state.data.map((item, i) => {
            if (this.props.productId !== item.id) {
              return (
                <Product key={i} {...item} showDescription={false} fixHeightContent={false}/>
              );
            }
          })
        }
      </section>
    );
  }
}

export default ListProductOther;



// WEBPACK FOOTER //
// ./components/product-detail/sub-view/list-product-other/ListProductOther.jsx